import axios from 'lib/axios'

export interface SubscriptionSummary {
  id: number
  name: string
  type: string
  formatted_type: string
  credits: number
  tests_used: number
  credits_available: number
  expiration_date: string
  comments: string | null
}

interface SubscriptionSummaryResponse {
  status: string
  data?: SubscriptionSummary
  message?: string
}

const fetchSubscriptionSummary = async (companyId: number): Promise<SubscriptionSummary | null> => {
  try {
    const response: SubscriptionSummaryResponse = await axios
      .get(`/company/subscription/summary/${companyId}`)
      .then((res) => res.data)

    if (response.status !== 'OK' || !response.data) {
      return null
    }

    return response.data
  } catch (error) {
    return null
  }
}

export default fetchSubscriptionSummary
